export const ERROR_FIELDS = {
  USER_NAME: 'username',
  PASSWORD: 'password',
};
